import { FormManager } from '@lib/FormManager.js';
import { UiLocker }    from '@lib/UiLocker.js';

export class LoginModal {
    static #BASE_URL = '/api/auth/v1/login';

    constructor(containerId = 'login-modal-container') {
        this.container = document.getElementById(containerId);
        this.dialog    = null;

        if (this.container) {
            this.#render();
        }
    }

    show() {
        this.dialog?.showModal();
    }

    #render() {
        this.container.innerHTML = `
            <dialog id="authModal" class="modal modal-sm">
                <div class="modal-head">
                    <div class="modal-title">Вход в систему</div>
                </div>
                <div class="modal-body">
                    <form id="loginForm" autocomplete="off" class="col gap-3">
                        <div class="field">
                            <label class="label">Email / Логин</label>
                            <input type="text" name="login" class="input" required>
                        </div>
                        <div class="field">
                            <label class="label">Пароль</label>
                            <input type="password" name="password" class="input" required>
                        </div>
                        <div id="loginError"></div>
                        <button type="submit" class="btn btn-primary w-full">Войти</button>
                    </form>
                </div>
            </dialog>`;

        this.dialog = document.getElementById('authModal');

        // Окно входа закрыть нельзя (это вся страница): Esc отключён, крестика нет.
        this.dialog.addEventListener('cancel', (e) => e.preventDefault());

        document.getElementById('loginForm')
            .addEventListener('submit', (e) => this.#handleSubmit(e));
    }

    async #handleSubmit(e) {
        e.preventDefault();

        const errorDiv = document.getElementById('loginError');
        const showError = (msg) => { errorDiv.className = 'alert is-error'; errorDiv.textContent = msg; };
        errorDiv.className = '';
        errorDiv.textContent = '';

        UiLocker.show('Выполняется вход...');

        try {
            const res = await FormManager.sendForm('loginForm', LoginModal.#BASE_URL);

            if (res.result) {
                // Не скрываем лоадер — страница сразу редиректится
                window.location.href = res.data?.redirect || '/';
            } else {
                showError(res.errMessage || 'Ошибка входа');
                UiLocker.hide();
            }
        } catch (err) {
            showError('Ошибка сети');
            UiLocker.hide();
        }
    }
}
